import React from 'react';
import { css } from 'linaria';
import { pdpSectionSideContentStyle } from './pdp-styles';
import { mutationCallback } from './utils';
import { SectionVlimit } from '../section-vlimit/section-vlimit';
import { AntifadeContainer } from '../section-vlimit/fade-container/fade-container';

export type PageSectionVariants = '' | 'v-limited';

export type PageSectionProps = {
  variant?: PageSectionVariants;
  sectionLocation?: string;
  headline?: React.ReactNode;
  sideContent?: React.ReactNode;
  onCollapsedToggle: (cancelAnimations?: boolean) => void;
  onSendAnalytics?: (isFade: boolean) => void;
  children?: React.ReactNode;
};

export const PageSection: React.FC<PageSectionProps> = ({
  sectionLocation,
  variant,
  children,
  headline,
  sideContent,
  onSendAnalytics,
  onCollapsedToggle,
}) => {
  let content = children;
  let current = __IS_SERVER__ ? null : document.getElementById(`section-${sectionLocation}`);
  // mutationObserver is used to listen web component attribute changes

  const observer = __IS_SERVER__ ? null : new MutationObserver(mutationCallback(onCollapsedToggle));
  if (current) {
    observer?.observe(current, { attributes: true });
  }

  if (variant?.toLocaleLowerCase() === 'v-limited') {
    content = (
      <SectionVlimit onSendAnalytics={onSendAnalytics} onCollapsedToggle={onCollapsedToggle}>
        {children}
      </SectionVlimit>
    );
  }

  if (sideContent) {
    content = (
      <>
        {content}
        <div className={pdpSectionSideContentStyle} slot="side-content">
          {sideContent}
        </div>
      </>
    );
  }

  return (
    <section>
      <AntifadeContainer />
      <div className={headlineContainer}>{headline}</div>
      <div className={contentStyles}>{content}</div>
    </section>
  );
};

const contentStyles = css`
  display: flex;
  @media screen and (max-width: 1023px) {
    display: block;
  }
  @media (--to-tablet) {
    padding-bottom: var(--space-400);
    margin: 0 var(--space-200);
  }
`;

const headlineContainer = css`
  margin-block: 16px;
  @media (--to-tablet) {
    margin-left: 16px;
  }
`;
